import { render, staticRenderFns } from "./template-list-measurements.vue?vue&type=template&id=37e968a6"
import script from "./template-list-measurements.vue?vue&type=script&lang=js"
export * from "./template-list-measurements.vue?vue&type=script&lang=js"
import style0 from "./template-list-measurements.vue?vue&type=style&index=0&id=37e968a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports